import * as v from 'valibot';

import { paginatedSchema } from '../_core.model';

const getOptionSchema = (message: string) => ({
  id: v.string(message),
  label: v.string(message),
});

const optionalStringSchema = v.pipe(
  v.nullish(v.string()),
  v.transform((value) => value ?? ''),
);

const optionalNumberSchema = v.pipe(
  v.nullish(v.number()),
  v.transform((value) => value ?? 0),
);

export const postalSearchFormSchema = v.object({
  additional: v.pipe(
    v.object({
      city: v.optional(v.string('City is required')),
      portPostal: v.optional(v.string('Port Postal is required')),
      state: v.optional(v.object(getOptionSchema('State is required'))),
    }),
    v.check(
      (input) => Boolean(input.state || input.city || input.portPostal),
      'At least one of City, Port Postal, or State is required',
    ),
  ),
  country: v.object(getOptionSchema('Country is required')),
});

export const postalSearchParamsSchema = v.object({
  city: v.optional(v.string()),
  country: v.optional(v.string()),
  limit: v.optional(v.pipe(v.number(), v.minValue(0)), 10),
  offset: v.optional(v.pipe(v.number(), v.minValue(0)), 0),
  portPostal: v.optional(v.string()),
  sorting: v.optional(v.string()),
  state: v.optional(v.string()),
});

export const postalApiSchema = v.object({
  cityName: optionalStringSchema,
  cityType: optionalStringSchema,
  countryCode: optionalStringSchema,
  creationTime: v.nullish(v.string()),
  creatorUserId: v.nullish(v.number()),
  id: v.number(),
  lastModificationTime: v.nullish(v.string()),
  lastModifierUserId: v.nullish(v.number()),
  latitude: optionalNumberSchema,
  longitude: optionalNumberSchema,
  postalCode: optionalStringSchema,
  stateCode: optionalStringSchema,
});

export const postalsResponseSchema = paginatedSchema(postalApiSchema);

export type PostalSearchFormValues = v.InferOutput<typeof postalSearchFormSchema>;
export type PostalsParams = v.InferOutput<typeof postalSearchParamsSchema>;
export type PostalApi = v.InferOutput<typeof postalApiSchema>;
export type PostalsResponse = v.InferOutput<typeof postalsResponseSchema>;
export type Postal = Omit<PostalApi, 'id'> & { id: string };
export type Postals = Postal[];
export type PostalsApi = { data: Postals; total: number };
